import { FC, ReactNode } from 'react';
import { cn } from './cn';

export const Title: FC<{ children: ReactNode; className?: string }> = ({ children, className = '' }) => {
  return <h1 className={cn('font-chinook text-[32px] leading-[120%] lg:text-[56px]', className)}>{children}</h1>;
};

export const TitleMedium: FC<{ children: ReactNode; className?: string }> = ({ children, className = '' }) => {
  return (
    <h1 className={cn('font-chinook text-2xl leading-[110%] font-extrabold md:text-[38px]', className)}>{children}</h1>
  );
};
export const TitleSmall: FC<{ children: ReactNode; className?: string }> = ({ children, className = '' }) => {
  return (
    <h1 className={cn('font-chinook text-2xl leading-[110%] font-extrabold md:text-[26px]', className)}>{children}</h1>
  );
};

export const BodySmall: FC<{ children: ReactNode; className?: string }> = ({ children, className = '' }) => {
  return <div className={cn('font-quicksand text-base leading-[140%] font-semibold', className)}>{children}</div>;
};

export const BodyBase: FC<{ children: ReactNode; className?: string }> = ({ children, className = '' }) => {
  return (
    <div
      className={cn('font-quicksand text-lg leading-[140%] font-semibold md:text-[19px] md:leading-[130%]', className)}
    >
      {children}
    </div>
  );
};

export const BodyMedium: FC<{ children: ReactNode; className?: string }> = ({ children, className = '' }) => {
  return <div className={cn('font-quicksand text-base leading-[140%] font-medium', className)}>{children}</div>;
};

export const BodySubheading: FC<{ children: ReactNode; className?: string }> = ({ children, className = '' }) => {
  return (
    <div className={cn('font-quicksand text-[22px] leading-[120%] font-bold md:text-[24px]', className)}>
      {children}
    </div>
  );
};

export const BodyHeading: FC<{ children: ReactNode; className?: string }> = ({ children, className = '' }) => {
  return (
    <div className={cn('font-chinook text-2xl leading-[140%] font-medium md:text-4xl md:leading-[2.5rem]', className)}>
      {children}
    </div>
  );
};

export const BodySubhero: FC<{ children: ReactNode; className?: string }> = ({ children, className = '' }) => {
  return (
    <div className={cn('font-quicksand text-lg leading-[120%] font-bold md:text-[26px] lg:text-[28px]', className)}>
      {children}
    </div>
  );
};

export const BodySmallHeading: FC<{ children: ReactNode; className?: string }> = ({ children, className = '' }) => {
  return <div className={cn('font-quicksand text-sm leading-[140%] font-semibold', className)}>{children}</div>;
};

export const BodySubtitle: FC<{ children: ReactNode; className?: string }> = ({ children, className = '' }) => {
  return (
    <div className={cn('font-quicksand text-[28px] leading-[120%] font-medium md:text-lg', className)}>{children}</div>
  );
};
